import { Switch } from '@headlessui/react';
import InnerHTMLContainer from '../../molecules/InnerHTMLContainer';
import { Icon } from '../Icon';

export interface CheckboxProps {
  disabled?: boolean;
  checked?: boolean;
  id?: string;
  label?: string;
  value?: string;
  type?: 'default' | 'indeterminate';
  variant?: 'default' | 'rounded';
  checkedColorType?: 'default' | 'success' | 'error' | 'correct';
  size?: 'default' | 'small';
  onChange?: () => void;
  order?: 'labelFirst' | 'checkboxFirst';
}

const Checkbox = ({
  id,
  label,
  value,
  checked,
  disabled = false,
  type = 'default',
  variant = 'default',
  checkedColorType = 'default',
  onChange,
  size = 'default',
  order = 'checkboxFirst',
}: CheckboxProps) => {
  const checkedColorStyle = {
    default: 'ring-color-brand-primary bg-color-brand-primary',
    success: 'ring-feedback-color-success-darkest bg-feedback-color-success-darkest',
    error: 'ring-feedback-color-error-darkest bg-feedback-color-error-darkest',
    correct: '',
  };

  return (
    <Switch.Group>
      <div
        className={` ${
          order === 'checkboxFirst' ? 'flex' : 'flex flex-row-reverse'
        } items-center gap-md`}
      >
        <Switch
          id={id}
          checked={checked}
          onClick={onChange}
          disabled={disabled}
          value={value}
          className={`relative flex items-center justify-center ${
            variant === 'rounded' ? 'rounded-sm' : ''
          } outline-none ring-2 transition-all duration-200 ${
            !checked
              ? `ring-mono-color-dark`
              : checkedColorStyle[checkedColorType]
          } ${size === 'default' ? 'h-5 w-5' : 'h-4 w-4'}`}
        >
          {type === 'default' ? (
            <Icon
              Icon='check'
              type='material'
              className={`${
                checked ? 'scale-100' : 'scale-0'
              } text-mono-color-white transition-transform duration-200 ease-out ${
                size === 'default' ? 'text-lg' : 'text-md'
              }`}
            />
          ) : (
            <Icon
              Icon='check-indeterminate-small'
              type='material'
              className={`${
                checked ? 'scale-100' : 'scale-0'
              } text-mono-color-white transition-transform duration-200 ease-out ${
                size === 'default' ? 'text-lg' : 'text-md'
              }`}
            />
          )}
        </Switch>
        {label && (
          <label className='cursor-pointer' onClick={onChange}>
            <InnerHTMLContainer
              data={label}
              type='courseProgram'
              className={`text-mono-color-darkest ${
                size === 'default' ? 'text-md' : 'text-sm'
              }`}
            />
          </label>
        )}
      </div>
    </Switch.Group>
  );
};

export default Checkbox;
